import React, { useContext } from "react";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Container, Modal, Spinner } from "react-bootstrap";
import { ERTDetailContext } from "../ERTDetailView";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import TableBody from "../../../constants/dummyData.json";
import DataTable from "../../../components/DataTableComponent/DataTable";
import Filter from "../../../assets/images/Icons/filter.svg";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
import Button from "../../../components/ButtonComponent/Button";

import "./ertDetailPage.css";
import { SwitchButton } from "../../../components/SwitchButton/SwitchButton";
import AlertBox from "../../../components/AlertComponent/AlertBox";

const ERTDetailPage = ({ textContents }) => {
  const {
    goBack,
    previousPage,
    previousScreen,
    pageContent, // Page content

    onClickShowModal, // function to show modal
    showModal, // state for modal
    handleClose, // function to close modal
    employeeTypeList, // list of employee type
    selectEmployeeType, // state for selected list time
    setSelectEmployeeType, // set state of selected item
    toogleCheck, // Present - absent status state
    onClickChangeStatus, // function to toggle button
    ertDetailsFilter, // filter submit function
    mainId, // id passing to API
    status, // Present - absent status state
    ertDetails, // table list - data
    showAlert, // error alert pop state
    setShowAlert, // error alert pop set-state
    alertMessage, // alert message state
    logout, // logout function (logout when session expire)
    statusCode, // state for status code
    handleAlertSubmit, // function to close alert
    spinner, // state for spinner
  } = useContext(ERTDetailContext);
  const ERTdata = TableBody.visitorsMapping;
  //console.log("ertDetails", ertDetails);
  const tableHeaderStatus = [
    { title: "Name", prop: "EmployeeName" },
    { title: "Employee Code", prop: "EmployeeCode" },
    { title: "Zone", prop: "DeviceFName" },
  ];

  const tableHeader = [
    {
      title: "Name/Contact",
      prop: "EmployeeName",
      cell: (row) => (
        <span>
          {row.EmployeeName}
          <br />
          <span className="employee-number">{row.ContactNo}</span>
        </span>
      ),
    },
    { title: "Employee Code", prop: "EmployeeCode" },
    {
      title: "Employee Type",
      prop: "CategoryName",
      cell: (row) => (
        <span className="type-margin-left">{row.CategoryName}</span>
      ),
    },
    { title: "Working Unit", prop: "WorkingUnit" },
    {
      title: "Supervisor No",
      prop: "SupervisorNumber",
      cell: (row) => (
        <span className="number-padding">{row.SupervisorNumber}</span>
      ),
    },
  ];

  return (
    <div className="ertDetailPage">
      <TopBar />
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => handleAlertSubmit()
        }
      />
      <Container>
        <div className="filterContainerZoneERTDeatail">
          <div className="arrowContainerERTDeatail" onClick={() => goBack()}>
            <img
              src={LeftArrow}
              alt="img"
              className="leftArrowZoneERTDeatail back-arrow"
            />
          </div>
          <div className="filterByContainerZoneERTDeatail">
            <span className="filterByZoneText">{previousPage}</span>
          </div>

          {/* filter */}
          <span className="ert-filter" onClick={onClickShowModal}>
            <img src={Filter} alt="Excel-icon" />
            {pageContent.filter}
          </span>
        </div>
        {ertDetails == null || undefined ? (
          <div className="filterByZoneText">{pageContent.noData}</div>
        ) : (
          <div className="tableContainerStatusZoneERTDeatail">
            {previousScreen == null ? (
              <DataTable
                tableData={ertDetails}
                header={tableHeader}
                isPagination={false}
              />
            ) : (
              <DataTable
                tableData={ertDetails}
                header={tableHeaderStatus}
                isPagination={false}
              />
            )}
          </div>
        )}
      </Container>

      {/* Filtering modal */}

      <Modal className="ertFilterModal" show={showModal} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="filter-text">{pageContent.filter}</div>
          <DropDownItem
            selectedItem={selectEmployeeType}
            setSelectedItem={setSelectEmployeeType}
            list={employeeTypeList}
            categoryRequired={false}
          />
          <div className="mt-4 toggle-button">
            <span className="status">{pageContent.status}</span>
            <span className="toggle-value">&nbsp;{pageContent.present}</span>
            <span className="mx-3">
              <SwitchButton
                checked={toogleCheck}
                onClick={onClickChangeStatus}
              />
            </span>
            <span className="toggle-value">{pageContent.absent}</span>
          </div>
          <Button
            text={spinner ? <Spinner size="sm" /> : pageContent.buttonText}
            customClass="my-4"
            onClick={() => {
              ertDetailsFilter(mainId, status, selectEmployeeType.id);
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ERTDetailPage;
